import { Section } from "../components/Section"

export const Summary = () => {
    return <Section title="SemEval-2026 Task 7: Everyday Knowledge Across Diverse Languages and Cultures" className="flex-1 pt-0" id="semeval_summary" remove_top_padding={true}>
        <p>
        A shared task on evaluating cultural awareness in language models across 26 languages and 30 countries and regions. Participants will use an extended BLEnD benchmark to test models’ understanding of everyday knowledge in diverse multilingual and multicultural contexts.
        </p>
    </Section>
}